import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import {
    redirectUnauthorizedTo,
    redirectLoggedInTo,
    canActivate,
} from '@angular/fire/auth-guard';

//Parte de la librería de Angular Firebase. Verifica si hay sesión de firebase y redirecciona en caso de que no.
const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['home']);

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./modules/start/start.module').then((m) => m.StartModule)
    },
    {
        path: 'session',
        loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule)
    },
    {
        path: 'home',
        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule)
    },
    {
        path: 'addresses',
        loadChildren: () => import('./modules/addresses/addresses.module').then((m) => m.AddressesModule),
        ...canActivate(redirectUnauthorizedToLogin)
    },
    {
        path: 'help',
        loadChildren: () => import('./modules/help/help.module').then((m) => m.HelpModule)
    },
    {
        path: 'chat',
        loadChildren: () => import('./modules/chat/chat.module').then((m) => m.ChatModule)
    },
    {
        path: 'profile',
        loadChildren: () => import('./modules/profile/profile.module').then((m) => m.ProfileModule),
        ...canActivate(redirectUnauthorizedToLogin)
    },
    {
        path: 'orders-history',
        loadChildren: () => import('./modules/orders-history/orders-history.module').then((m) => m.OrdersHistoryModule),
        ...canActivate(redirectUnauthorizedToLogin)
    },
    {
        path: 'modal-stiker',
        loadChildren: () => import('./modules/calification/modal-stiker/modal-stiker.module').then((m) => m.ModalStikerModule)
    },
    {
        path: 'notifications',
        loadChildren: () => import('./modules/notifications/notifications.module').then(m => m.NotificationsModule)
    },
    {
        path: 'hallowen-questions',
        loadChildren: () => import('./modules/questions/questions.module').then(m => m.QuestionsModule)
    },
    {
        path: 'record',
        loadChildren: () => import('./modules/profile/pet-record/pet-record.module').then(m => m.PetRecordModule)
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
